<template>
  <v-container>
    <v-layout row pt-10>
      <v-flex xs12 sm6 offset-sm3>
        <h2 class="primary--text">Invite faculty</h2>
        <p class="muted">
          They’ll go to dashboard.iabf.dance, enter this email, and set a password.
          Assign a room here if they need a bed — it counts against inventory.
          They won’t see or change room on their own dashboard.
        </p>
        <form @submit.prevent="onCreate">
          <v-text-field v-model="firstName" label="First name" required />
          <v-text-field v-model="lastName" label="Last name" required />
          <v-text-field v-model="email" label="Email" type="email" required />
          <v-text-field v-model="phone" label="Phone" type="tel" />
          <v-text-field
            v-model="yearsAtIabf"
            label="Years at IABF (including this year)"
            type="number"
            min="1"
            max="40"
            hint="Shows on their community intro as “Nth year at IABF.” 1 = first year."
            persistent-hint
          />
          <v-select
            v-model="room"
            label="Room (admin only)"
            :items="roomItems"
            item-text="text"
            item-value="value"
          />
          <v-text-field
            v-model="arrivalDate"
            label="Arrives"
            type="date"
            hint="Meals start from this day (dinner on arrival, breakfast the next morning)"
            persistent-hint
          />
          <v-text-field
            v-model="departureDate"
            label="Leaves"
            type="date"
            hint="Breakfast on this day; no lunch or dinner after they leave"
            persistent-hint
          />
          <v-text-field
            v-model="honorariumUsd"
            label="Pay (USD)"
            type="number"
            min="0"
            step="0.01"
            prefix="$"
          />
          <v-text-field
            v-model="travelReimbursedUsd"
            label="Travel reimbursed (USD)"
            type="number"
            min="0"
            step="0.01"
            prefix="$"
          />
          <v-text-field
            v-model="otherReimbursedUsd"
            label="Other expenses reimbursed (USD)"
            type="number"
            min="0"
            step="0.01"
            prefix="$"
          />
          <v-text-field
            v-model="payNotes"
            label="Pay / reimbursement notes"
          />
          <p v-if="error" class="error">{{ error }}</p>
          <v-btn class="primary" type="submit" :loading="saving" :disabled="!canSave">
            Add faculty
          </v-btn>
          <v-btn text to="/iabf/admin/faculty">Cancel</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { FACULTY_ROOM_ITEMS, facultyYearsAtIabfNum } from '@/utils/iabf-faculty'
import { festivalWeek } from '@/config/iabf-festival-dates'

export default {
  name: 'CreateFaculty',
  data () {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      room: '',
      arrivalDate: '',
      departureDate: '',
      honorariumUsd: '',
      travelReimbursedUsd: '',
      otherReimbursedUsd: '',
      payNotes: '',
      yearsAtIabf: 1,
      roomItems: FACULTY_ROOM_ITEMS,
      saving: false,
      error: ''
    }
  },
  computed: {
    canSave () {
      return !!(this.firstName.trim() && this.lastName.trim() && this.email.trim())
    }
  },
  created () {
    this.$store.commit('setLayout', 'iabf-layout')
    const week = festivalWeek(this.$store.getters.adminFestivalYear)
    this.arrivalDate = week.arrivalIso
    this.departureDate = week.departureIso
  },
  methods: {
    async onCreate () {
      this.saving = true
      this.error = ''
      try {
        await this.$store.dispatch('createIabfFaculty', {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
          room: this.room,
          arrivalDate: this.arrivalDate,
          departureDate: this.departureDate,
          honorariumUsd: this.honorariumUsd,
          travelReimbursedUsd: this.travelReimbursedUsd,
          otherReimbursedUsd: this.otherReimbursedUsd,
          payNotes: this.payNotes,
          yearsAtIabf: facultyYearsAtIabfNum(this.yearsAtIabf) || 1
        })
        this.$router.push('/iabf/admin/faculty')
      } catch (e) {
        this.error = (e && e.message) || 'Could not add faculty.'
      }
      this.saving = false
    }
  }
}
</script>

<style scoped>
.muted { color: #666; margin-bottom: 16px; }
.error { color: #c62828; }
</style>
